import * as React from 'react';
import { DemographicQuestionListContainer } from '../../../containers/questions/DemographicQuestionListContainer';

export interface IDemographicQuestionModalContentProps {
	isLoading: boolean;
	selectedQuestionVariationIds: number[];
	selectedCustomQuestionIds: number[];
}

export class DemographicQuestionModalContent extends React.PureComponent<IDemographicQuestionModalContentProps> {
	constructor(props: any) {
		super(props);
	}

	public render() {
		const totalSelectedQuestions = this.props.selectedQuestionVariationIds.length + this.props.selectedCustomQuestionIds.length;
		return (
			<DemographicQuestionListContainer
				selectedQuestionVariationIds={this.props.selectedQuestionVariationIds}
				totalSelectedQuestions={totalSelectedQuestions}
			/>
		);
	}
}
